import { resolveEnvPlaceholders } from './env-placeholders'

export { resolveEnvPlaceholders } from './env-placeholders'

const requestTimeoutMs = Number(import.meta.env.VITE_REQUEST_TIMEOUT_MS)

export const env = {
  // 是否启用开发行为。Vite dev server 下 DEV 为 true；构建模式可用 VITE_DEV=true 显式开启。
  dev: import.meta.env.DEV || import.meta.env.VITE_DEV === 'true',
  // 应用标题
  appTitle: import.meta.env.VITE_APP_TITLE,
  // SaaS 后端 API 地址（本地开发默认 localhost:8090）
  apiBaseUrl: resolveEnvPlaceholders(import.meta.env.VITE_API_BASE_URL),
  // 未配置时沿用 Axios 默认超时
  requestTimeoutMs: Number.isSafeInteger(requestTimeoutMs) && requestTimeoutMs > 0 ? requestTimeoutMs : undefined,
  // ERP/环境 API 地址（本地未部署模块跟随测试环境）
  apiErpBaseUrl: resolveEnvPlaceholders(import.meta.env.VITE_API_ERP_BASE_URL),
  // ERP Gateway API 地址
  apiErpGatewayBaseUrl: resolveEnvPlaceholders(import.meta.env.VITE_API_ERP_GATEWAY_BASE_URL),
  // 基础配置服务地址（数据字典等独立配置系统）
  baseConfigUrl: resolveEnvPlaceholders(import.meta.env.VITE_BASE_CONFIG_URL),
  // SSO 授权服务地址
  ssoServer: resolveEnvPlaceholders(import.meta.env.VITE_SSO_SERVER),
  // OAuth 公共客户端 ID；必须与 Go 后端 JWT audience 保持一致
  clientId: import.meta.env.VITE_CLIENT_ID,
  // 账号密码登录仅在本地开发和测试环境显式开放
  passwordLoginEnabled: import.meta.env.VITE_PASSWORD_LOGIN_ENABLED === 'true',
  // 仓储管理系统（WMS）地址
  wmsUrl: resolveEnvPlaceholders(import.meta.env.VITE_WMS_URL),
  // 商品ERP系统地址
  erpUrl: resolveEnvPlaceholders(import.meta.env.VITE_ERP_URL),
  // 商品系统（PMS）地址
  pmsUrl: resolveEnvPlaceholders(import.meta.env.VITE_PMS_URL),
  // 采购系统地址
  purchaseUrl: resolveEnvPlaceholders(import.meta.env.VITE_PURCHASE_URL),
  // SCM 前端地址
  scmHost: resolveEnvPlaceholders(import.meta.env.VITE_SCM_HOST),
  // 旧供应商门户地址
  legacySupplierUrl: resolveEnvPlaceholders(import.meta.env.VITE_LEGACY_SUPPLIER_URL),
  // 旧工厂门户地址
  legacyGcUrl: resolveEnvPlaceholders(import.meta.env.VITE_LEGACY_GC_URL),
  // 用户系统地址
  userUrl: resolveEnvPlaceholders(import.meta.env.VITE_USER_URL),
  // Office Online / OnlyOffice 文件预览地址
  officeHost: resolveEnvPlaceholders(import.meta.env.VITE_OFFICE_HOST),
  // 是否使用本地 mock 数据
  useMock: import.meta.env.VITE_USE_MOCK === 'true',
} as const
